import { ROUTES } from '@/constants';
import { ax } from '@/utils';

const state = {
    bookmarks: []
};

const getters = {
    bookmarks: state => state.bookmarks
};

const actions = {
    getBookmarks({ commit }) {
        return ax
            .get(ROUTES.GET_BOOKMARKS())
            .then(res => {
                commit('SET_BOOKMARKS', res.data.bookmarks || []);
                return res;
            })
            .catch(error => Promise.reject(error));
    },

    createBookmark({ commit }, payload) {
        return ax
            .post(ROUTES.CREATE_BOOKMARK(), payload)
            .then(res => {
                commit('ADD_BOOKMARK', res.data.bookmark || payload);
                return res;
            })
            .catch(error => Promise.reject(error));
    },

    deleteBookmark({ commit }, id) {
        return ax
            .delete(ROUTES.DELETE_BOOKMARK(id))
            .then(res => {
                commit('REMOVE_BOOKMARK', id);
                return res;
            })
            .catch(error => Promise.reject(error));
    }
};

const mutations = {
    SET_BOOKMARKS(state, bookmarks) {
        state.bookmarks = bookmarks;
    },
    ADD_BOOKMARK(state, bookmark) {
        state.bookmarks = [bookmark, ...state.bookmarks];
    },
    REMOVE_BOOKMARK(state, id) {
        state.bookmarks = state.bookmarks.filter(b => b._id !== id);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
